// See https://www.imsglobal.org/specs/ltiv1p0/implementation-guide (A.2.2: LIS vocabulary for Institution Role)

export enum ImsRole {
  Student = 'urn:lti:instrole:ims/lis/Student',
  Faculty = 'urn:lti:instrole:ims/lis/Faculty',
  Member = 'urn:lti:instrole:ims/lis/Member',
  Learner = 'urn:lti:instrole:ims/lis/Learner',
  Instructor = 'urn:lti:instrole:ims/lis/Instructor',
  Mentor = 'urn:lti:instrole:ims/lis/Mentor',
  Staff = 'urn:lti:instrole:ims/lis/Staff',
  Alumni = 'urn:lti:instrole:ims/lis/Alumni',
  ProspectiveStudent = 'urn:lti:instrole:ims/lis/ProspectiveStudent',
  Guest = 'urn:lti:instrole:ims/lis/Guest',
  Other = 'urn:lti:instrole:ims/lis/Other',
  Administrator = 'urn:lti:instrole:ims/lis/Administrator',
  Observer = 'urn:lti:instrole:ims/lis/Observer',
  None = 'urn:lti:instrole:ims/lis/None'
}
export default ImsRole;
